import { debounce } from '@utils/debounce';

export const useCheckoutTheMachine = () => {
  // Only run if the screen width is greater than 992px
  if (window.innerWidth < 992) {
    return;
  }

  const checkoutTheMachine = (document.querySelector(".checkout-the-machine") as HTMLElement);
  const zoneBlocks = document.querySelectorAll(".zone-block") as NodeListOf<HTMLElement>;
  const zoneImages = document.querySelectorAll(".checkout-the-machine__select-image") as NodeListOf<HTMLElement>;
  const imageWrapper = document.querySelector(".checkout-the-machine__image-wrapper") as HTMLElement;
  const checkoutTheMachineHeadingHeight = (document.querySelector(".checkout-the-machine__heading") as HTMLElement)?.offsetHeight ?? 0;
  const lastZoneImage = zoneImages[zoneImages.length - 1];

  // Set CSS variable for --checkout-the-machine-offset
  checkoutTheMachine.style.setProperty("--checkout-the-machine-offset", `${checkoutTheMachineHeadingHeight}px`);

  const runCheckoutTheMachine = () => {
    const headerHeight = (document.querySelector(".header") as HTMLElement).getBoundingClientRect().height;
    const checkoutTheMachineOffset = checkoutTheMachine.offsetTop - headerHeight;
    const checkOutTheMachineHeight = checkoutTheMachine.offsetHeight;
    const scrollY = window.scrollY;

    if (!!imageWrapper){
      // Set image height based on the height of the first image
      imageWrapper.style.height = `${zoneImages[0].offsetHeight}px`; 
    }

    // Activate or deactivate the checkout-the-machine based on scroll position
    if (scrollY >= checkoutTheMachineOffset && scrollY <= checkoutTheMachineOffset + checkOutTheMachineHeight - 350) {
      document.body.classList.add("checkout-the-machine-is-active");
      checkoutTheMachine.classList.add("checkout-the-machine--active");
      checkoutTheMachine.classList.remove("checkout-the-machine--end-of-scroll");
    }
    // Add class to checkoutTheMachine when it reaches the end of the scroll
    else if (scrollY > checkoutTheMachineOffset + checkOutTheMachineHeight - 350) {
      if (!checkoutTheMachine.classList.contains("checkout-the-machine--end-of-scroll")) {
        checkoutTheMachine.classList.add("checkout-the-machine--end-of-scroll");
      }

      if (checkoutTheMachine.classList.contains("checkout-the-machine--active")) {
        document.body.classList.remove("checkout-the-machine-is-active");
        checkoutTheMachine.classList.remove("checkout-the-machine--active");
      }
    } else {
      // Remove class from checkoutTheMachine when it's not in view
      if (checkoutTheMachine.classList.contains("checkout-the-machine--active")) {
        document.body.classList.remove("checkout-the-machine-is-active");
        checkoutTheMachine.classList.remove("checkout-the-machine--active");
      }

      // Remove class from checkoutTheMachine when it's not in view
      if (checkoutTheMachine.classList.contains("checkout-the-machine--end-of-scroll")) {
        checkoutTheMachine.classList.remove("checkout-the-machine--end-of-scroll");
      }
    }

    // Handle fading in/out of images based on scroll position for each zone block
    zoneBlocks.forEach((block, index) => {
      const blockTop = block.offsetTop - 250;
      const blockBottom = blockTop + block.offsetHeight;
      const zoneBlockId = block.id;
      const currentZoneImage = zoneImages[index];

      // Add active class to the last zone image when checkoutTheMachine reaches the end of the scroll
      if (checkoutTheMachine.classList.contains("checkout-the-machine--end-of-scroll")) {
        if (!lastZoneImage?.classList.contains("checkout-the-machine__select-image--active")) {
          lastZoneImage?.classList.add("checkout-the-machine__select-image--active");
        }
      }
      // Add active class to the corresponding zone block and zone image
      else if (scrollY >= blockTop && scrollY <= blockBottom) {
        block.classList.add("zone-block--active");
        document.getElementById(`${zoneBlockId}-anchor`)?.classList.add("checkout-the-machine__select-item--active");
        currentZoneImage?.classList.add("checkout-the-machine__select-image--active");
      }
      // Remove active class from the corresponding zone block and zone image
      else {
        block.classList.remove("zone-block--active");
        document.getElementById(`${zoneBlockId}-anchor`)?.classList.remove("checkout-the-machine__select-item--active");
        currentZoneImage?.classList.remove("checkout-the-machine__select-image--active");
        lastZoneImage?.classList.remove("checkout-the-machine__select-image--active");
      }
    });
  };

  // Scroll to the corresponding zone block when clicking on the zone link
  document.querySelectorAll('.checkout-the-machine__select-item').forEach(element => {
    const item = element as HTMLElement
    item.addEventListener("click", function(e) {
      e.preventDefault();
      const zoneBlockLink = item.dataset.zoneLink!;
      const zoneBlock = document.getElementById(zoneBlockLink);
      const zoneBlockTop = zoneBlock!.offsetTop - 140;
      window.scrollTo({top: zoneBlockTop, behavior: "smooth"});
    });
  });

  // Scroll event listener for showing checkoutTheMachine section
  window.addEventListener("scroll", () => {
    runCheckoutTheMachine();
  });
};

document.addEventListener("DOMContentLoaded", function() {
  // Add a timeout to simulate loading and avoid flickering
  setTimeout(() => {
    document.querySelector(".checkout-the-machine__content")?.classList.remove("checkout-the-machine__content--loading");
    useCheckoutTheMachine();
  }, 1500);

  // Listen for resize events to check if the screen width is greater than 992px
  window.addEventListener("resize", debounce(() => {
    if (window.innerWidth > 992) {
      useCheckoutTheMachine();
    }
  }, 250));
});
